import { bemComponent } from '@99designs/utils/app';

export default bemComponent('spinner-container');



// WEBPACK FOOTER //
// ./js/launch/components/SpinnerContainer.jsx